import {
  doc,
  getDoc,
  getFirestore,
} from 'firebase/firestore';

/**
 * Checks if the session code in Firestore matches localStorage. Logs out and redirects if not.
 * @param sessionId The session document ID
 * @param navigate Optional: a navigate function from react-router-dom. If not provided, uses window.location.href
 */
export async function checkSessionCodeAndLogoutIfChanged(sessionId: string, navigate?: (url: string) => void) {
  if (!sessionId) return;
  const db = getFirestore();
  const sessionDoc = await getDoc(doc(db, 'sessions', sessionId));
  if (!sessionDoc.exists()) return;
  const sessionData = sessionDoc.data();
  const storedSessionCode = localStorage.getItem('sessionCode');
  if (storedSessionCode && sessionData.code && storedSessionCode !== sessionData.code) {
    localStorage.removeItem('sessionId');
    localStorage.removeItem('coachName');
    localStorage.removeItem('sessionCode');
    if (navigate) {
      navigate('/join');
    } else {
      window.location.href = '/join';
    }
  }
} 